<template>
  <div>
    <v-overlay :value="loading" :z-index="9999" opacity="0.9">
      <v-row class="fill-height" align="center" justify="center" style="flex-direction: column; text-align: center">
        <v-progress-circular indeterminate size="70" color="primary" class="mb-4" />
        <div class="text-h6 white--text">
          Anfrage wird bearbeitet! Upload erfolgt! Bitte warten...
        </div>
      </v-row>
    </v-overlay>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-btn
            :class="$vuetify.breakpoint.smAndDown ? '' : 'v-size--large'"
            :block="$vuetify.breakpoint.smAndDown"
            color="success"
            @click="openDialog({
              send_chat: 0,
              show_overlay: 0,
              avatar_position: 'bottom-left',
              is_enabled: 1,
            })"
          >Usersound erstellen</v-btn>
        </v-col>
        <v-col cols="12" sm="6" :class="$vuetify.breakpoint.smAndDown ? '' : 'text-right'">
          <v-btn
            @click="toggleText"
            color="success"
            :block="$vuetify.breakpoint.smAndDown"
          >How To</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div class="userSoundsWrapper" :class="{ drawerOpen: !$store.state.navigation_drawer_mini, 'mobile-wrapper': $vuetify.breakpoint.smAndDown }">
      <v-row>
        <v-col v-for="item in sortedUserSounds" :key="item.id" cols="12" sm="6" md="4" lg="4">
          <v-card outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-h6 mb-2">{{ item.username }}</div>
                <v-list-item-subtitle v-if="item.title">{{ item.title }}</v-list-item-subtitle>
                <v-list-item-subtitle>
                  <v-icon small :color="item.is_enabled ? 'success' : 'grey'">
                    {{ item.is_enabled ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  {{ item.is_enabled ? 'Aktiv' : 'Deaktiviert' }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar
                tile
                :size="$vuetify.breakpoint.smAndDown ? 60 : 80"
                color="grey"
                v-if="item.img !== null && item.img !== ''"
              >
                <img :src="getItemImage(item.img)" alt="Vorschau">
              </v-list-item-avatar>
            </v-list-item>
            <v-card-actions class="flex-wrap">
              <v-btn
                color="primary"
                dark
                :block="$vuetify.breakpoint.smAndDown"
                :class="{ 'mb-2': $vuetify.breakpoint.smAndDown }"
                @click="openDialog(item)"
              >
                Bearbeiten
              </v-btn>
              <v-btn
                color="secondary"
                dark
                :block="$vuetify.breakpoint.smAndDown"
                :class="$vuetify.breakpoint.smAndDown ? '' : 'ml-2'"
                @click="testUserSound(item)"
              >
                Testen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="showText" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showText = !showText">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>How To?</v-card-title>
        <v-card-text>
          <div>
            <p>
              Wie funktionieren Usersounds? <br><br>

              Hier kannst du einzelnen Usern einen persönlichen Alert zuweisen. Sobald dieser User im aktuellen
              Stream seine erste Chatnachricht schreibt, kann der Bot einen Sound abspielen, ein Gif/Video und/oder
              eine Nachricht ausgeben. Pro Stream wird der Alert für einen User nur einmal ausgelöst.<br><br>

              Der Alert wird über dieselbe OBS-Browserquelle ausgegeben wie die Loyalty Rewards. Falls du diese
              bereits eingerichtet hast, ist keine weitere Quelle nötig. Andernfalls füge in OBS eine neue
              Browserquelle hinzu mit Breite 1920px und Höhe 1080px.<br><br>

              Der Link lautet wie folgt:<font color="red"> {{baseUrl}}/alert/{{cmdlist_pubid}}</font><br><br>

              In der Nachricht kannst du den Platzhalter <b>{user}</b> verwenden, dieser wird automatisch durch den
              Anzeigenamen des Users ersetzt.<br><br>
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-model="formValid">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Usersound</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="secondary" @click="testUserSound(selectedItem)" :hidden="selectedItem.id === undefined">
              Testen
            </v-btn>
            <v-btn color="error" @click="deleteUserSound" :hidden="selectedItem.id === undefined">
              Delete
            </v-btn>
            <v-btn color="success" @click="saveChanges">
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container class="pa-4">
          <v-subheader>Grundeinstellungen</v-subheader>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="selectedItem.username"
                label="Twitch-Username"
                outlined
                required
                :rules="[(v) => !!v || 'Feld darf nicht leer sein']"
                :disabled="selectedItem.id !== undefined"
                hint="Der Twitch-Login/Anzeigename des Users"
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="selectedItem.message"
                label="Nachricht"
                rows="2"
                auto-grow
                outlined
                counter="300"
                maxLength="300"
                hint="{user} wird durch den Anzeigenamen des Users ersetzt"
                persistent-hint
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox v-model="selectedItem.send_chat" :true-value="1" :false-value="0" label="Nachricht im Chat senden"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox v-model="selectedItem.show_overlay" :true-value="1" :false-value="0" label="Nachricht im Overlay anzeigen"></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="~~selectedItem.show_overlay === 1">
              <v-radio-group v-model="selectedItem.avatar_position" label="Position des Profilbild-Popups" row>
                <v-radio label="Unten links" value="bottom-left"></v-radio>
                <v-radio label="Unten rechts" value="bottom-right"></v-radio>
                <v-radio label="Oben links" value="top-left"></v-radio>
                <v-radio label="Oben rechts" value="top-right"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6">
              <v-file-input v-model="selectedItem.img" label="Bild / Gif auswählen" truncate-length="15"
                @change="onFileChange"></v-file-input>
              <v-btn
                v-if="selectedItem.img !== null && selectedItem.img !== '' && selectedItem.img !== undefined"
                color="red"
                @click="selectedItem.img = null"
              >Bild löschen</v-btn>
              <v-img :src="getItemImage(selectedItem.img)" max-width="100" max-height="100" class="mt-4"
                v-if="selectedItem.img !== null && selectedItem.img !== '' && selectedItem.img !== undefined"></v-img>
            </v-col>
            <v-col cols="12" sm="6">
              <v-file-input v-model="selectedItem.sound" label="Sound / Video auswählen" truncate-length="15"
                @change="onSoundChange"></v-file-input>
              <v-btn v-if="selectedItem.sound" color="red" @click="selectedItem.sound = null">Sound löschen</v-btn>
              <figure v-if="selectedItem.sound" class="mt-4">
                <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
                <audio controls :src="getItemImage(selectedItem.sound)" aria-hidden="true"></audio>
              </figure>
            </v-col>
            <v-col cols="12" sm="6" v-if="selectedItem.id">
              <v-switch v-model="selectedItem.is_enabled" label="Usersound aktiv" color="success"
                :true-value="1" :false-value="0" hide-details></v-switch>
            </v-col>
          </v-row>
        </v-container>
        </v-form>
      </v-card>
      <v-snackbar
        v-model="ErrorFlag"
        timeout="3000"
        color="red"
      >
        Überprüfe die roten Felder!

        <template v-slot:actions>
          <v-btn color="pink" variant="text" @click="ErrorFlag = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card>
        <v-card-title class="text-h5">Bist du dir sicher, dass dieser Usersound gelöscht werden soll?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="errorSnackbar" timeout="5000" color="red">
      {{ dynamicErrorMsg }}

      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="errorSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="infoSnackbar" timeout="3000" color="success">
      Test ausgelöst!

      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="infoSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      dialogDelete: false,
      showDialog: false,
      userSounds: [],
      errorSnackbar: false,
      infoSnackbar: false,
      dynamicErrorMsg: '',
      selectedItem: {
        id: undefined,
        username: '',
        title: '',
        message: '',
        send_chat: 0,
        show_overlay: 0,
        avatar_position: 'bottom-left',
        img: null,
        sound: null,
        is_enabled: 1,
      },
      loading: false,
      previousFile: null,
      fileChanged: false,
      fileWasCleared: false,
      fileInitiallySelected: false,
      previousSound: null,
      soundChanged: false,
      soundWasCleared: false,
      soundInitiallySelected: false,
      showText: false,
      baseUrl: '',
      cmdlist_pubid: '',
      formValid: false,
      ErrorFlag: false,
    };
  },
  mounted() {
    this.baseUrl = window.location.origin;
    BackendService.loadUserSounds().then((data) => {
      this.userSounds = data.data;
    });
    BackendService.loadCMD_PubID({
      broadcasterid: this.$store.state.hostId,
    }).then((data) => {
      this.cmdlist_pubid = data.data.cmdlist_pubid;
    });
  },
  computed: {
    sortedUserSounds() {
      const sortedArray = this.userSounds.slice();
      sortedArray.sort((a, b) => a.username.localeCompare(b.username));
      return sortedArray;
    },
  },
  methods: {
    toggleText() {
      this.showText = !this.showText;
    },
    onFileChange(file) {
      if (!file) {
        this.fileWasCleared = true;
        this.previousFile = null;
        return;
      }

      this.fileWasCleared = false;

      if (!this.fileInitiallySelected) {
        this.fileInitiallySelected = true;
        this.fileChanged = true;
      }

      if (
        !this.previousFile
        || file.name !== this.previousFile.name
        || file.size !== this.previousFile.size
        || file.lastModified !== this.previousFile.lastModified
      ) {
        this.fileChanged = true;
        this.previousFile = file;
      } else {
        this.fileChanged = false;
      }
    },
    onSoundChange(sound) {
      if (!sound) {
        this.soundWasCleared = true;
        this.previousSound = null;
        return;
      }

      this.soundWasCleared = false;

      if (!this.soundInitiallySelected) {
        this.soundInitiallySelected = true;
        this.soundChanged = true;
      }

      if (
        !this.previousSound
        || sound.name !== this.previousSound.name
        || sound.size !== this.previousSound.size
        || sound.lastModified !== this.previousSound.lastModified
      ) {
        this.soundChanged = true;
        this.previousSound = sound;
      } else {
        this.soundChanged = false;
      }
    },
    getItemImage(path) {
      if (path === null || path === '' || path === undefined) {
        return '';
      }
      return `${process.env.VUE_APP_BACKENDSERVICE_BASEURL}img/${path}`;
    },
    openDialog(item) {
      this.selectedItem = { ...item };
      this.fileWasCleared = false;
      this.fileChanged = false;
      this.fileInitiallySelected = false;
      this.previousFile = null;
      this.soundWasCleared = false;
      this.soundChanged = false;
      this.soundInitiallySelected = false;
      this.previousSound = null;
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    saveChanges() {
      if (this.$refs.form.validate()) {
        this.selectedItem.deleteCurrentImage = this.fileWasCleared;
        this.selectedItem.changeCurrentImage = this.fileChanged;
        this.selectedItem.deleteCurrentSound = this.soundWasCleared;
        this.selectedItem.changeCurrentSound = this.soundChanged;
        this.loading = true;

        const request = this.selectedItem.id
          ? BackendService.updateUserSound(this.selectedItem)
          : BackendService.createUserSound(this.selectedItem);

        request.then((data) => {
          this.userSounds = data.data;
          this.showDialog = false;
        }).catch((error) => {
          if (error.response && error.response.status === 409 && error.response.data === 'twitchuser_not_found') {
            this.dynamicErrorMsg = 'Der angegebene Twitchuser wurde nicht gefunden!';
            this.errorSnackbar = true;
          } else if (error.response && error.response.status === 409 && error.response.data === 'user_already_exists') {
            this.dynamicErrorMsg = 'Für diesen User existiert bereits ein Usersound!';
            this.errorSnackbar = true;
          }
        }).finally(() => {
          this.loading = false;
        });
      } else this.ErrorFlag = true;
    },
    deleteUserSound() {
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      BackendService.deleteUserSound(this.selectedItem).then((data) => {
        this.dialogDelete = false;
        this.showDialog = false;
        this.userSounds = data.data;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    testUserSound(item) {
      BackendService.testUserSound({ id: item.id }).then(() => {
        this.infoSnackbar = true;
      }).catch(() => {
        this.dynamicErrorMsg = 'Test konnte nicht ausgelöst werden!';
        this.errorSnackbar = true;
      });
    },
  },
};
</script>
<style scoped>
html, body {
  margin: 0;
  padding: 0;
  background: transparent;
  overflow: auto;
}

.userSoundsWrapper {
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
  background: transparent;
  margin: 0;
}
</style>
